<template>
	<div class="w-100 p-3 bg-white border-15 h-center">
		<div style="width: 75%; max-width: 500px;">
			<textInput
				label = "نام و نام خانوادگی"
				@inputTxtFunc = "(e)=>{val.name = e}"
				:val="val.name"
				autofocus="true"
			/>
			<textInput
				type="email"
				label = "ایمیل(اختیاری)"
				@inputTxtFunc = "(e)=>{val.email = e}"
				:val="val.email"
			/>
			<textInput
				label = "نام کاربری"
				@inputTxtFunc = "(e)=>{val.username = e}"
				:val="val.username"
			/>
			<textInput
				type="password"
				label = "کلمه عبور"
				@inputTxtFunc = "(e)=>{val.password = e}"
				:val="val.password"
			/>
			<textInput
				type="password"
				label = "کلمه عبور"
				@inputTxtFunc = "(e)=>{val.password2 = e}"
				:val="val.password2"
			/>
			<selectInput
				@inputTxtFunc = "(e)=>{val.field = e}"
				:value = "val.field"
				label="دپارتمان"
				placeholder="دپارتمان"
				:flds="field_data"
			/>
			<selectInput
				@inputTxtFunc = "(e)=>{val.access_level = e}"
				:value = "val.access_level"
				label="سطح"
				:flds="[
					{'id': '0','name': 'مدیر کل'},
					{'id': '3','name': 'کارشناس  پشتیبانی'},
				]"
			/>
			<selectInput
				@inputTxtFunc = "(e)=>{val.status = e}"
				:value = "val.status"
				label="وضعیت"
				:flds="[{'id': '1','name': 'وضعیت فعال'},{'id': '0','name': 'وضعیت غیر فعال'}]"
			/>
			<btn
				class="w-100 mt-3"
				textClass="w-100"
				text="ذخیره"
				@clickMe="sav()"
				:disable = "setDisableBtn()"
				:disableText = "setDisableBtnText()"
			/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import switchInput from  "../../UI/input/switchInput.vue";
		import textInput from  "../../UI/input/textInput.vue";
		import datepicker from  "../../UI/input/datepicker.vue";
		import multiSelectInput from  "../../UI/input/multiSelectInput.vue";
		import selectInput from  "../../UI/input/selectInput.vue";
		import textareaInput from  "../../UI/input/textareaInput.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import previewImage from  "../../UI/uploadFile/previewImage.vue";
		import { validateEmail } from  "../../assets/library/filter.js";
		import { time2minutes, minutes2time, classTime, timeOptions, vlaTimeOptions } from  "../../assets/library/convertTime.js";
		import { error, success, loading } from  "../../assets/library/messege.js";

		export default {
			name: 'self_part1',
			data(){
				return {
					imgurl: window.imgurl,
					baseurl: window.baseurl,
					time2minutes: time2minutes,
					minutes2time: minutes2time,
					classTime: classTime,
					timeOptions: timeOptions,
					vlaTimeOptions: vlaTimeOptions,

					error: error,
					success: success,
					loading: loading,
					field_data: [],
					val:{
						name: '',
						field: '-1',
						email: '',
						username: '',
						password: '',
						password2: '',
						status: '1',
						access_level: "0",
					},
				}
			},
			components: {
				btn,
				switchInput,
				vlaTimeOptions,
				classTime,
				timeOptions,
				time2minutes,
				minutes2time,
				datepicker,
				textInput,
				selectInput,
				pageNavigation,
				userImg,
				previewImage,
				textareaInput,
				multiSelectInput,
			},
			props: {
				
			},
			mounted(){
				this.field();
				(this.$route.params.id != undefined) ? this.loader() : '';
			},
			methods:{
				setDisableBtn(){
					let res = 0;
					if(this.val.email != '' && !validateEmail(this.val.email) ){
						res = 1;
					}
					if(this.val.name == '' || this.val.username == '' ){
						res = 1;
					}
					if(this.val.password != this.val.password2 ){
						res = 1;
					}
					if(!this.$route.params.id && (this.val.password == '' || this.val.password2 == '') ){
						res = 1;
					}
					return res;
				},
				//______________________________________________________________________
				setDisableBtnText(){
					let res = '';
					if(this.val.email != '' && !validateEmail(this.val.email) ){
						res = "ایمیل اشتباه است";
					}
					if(this.val.password != this.val.password2 ){
						res = "گذرواژه ها برابر نیستند";
					}
					if(this.val.name == '' || this.val.username == '' ){
						res = "اطلاعات را تکمیل نمایید";
					}
					if(!this.$route.params.id && (this.val.password == '' || this.val.password2 == '') ){
						res = "کلمه عبور را وارد نمایید";
					}
					return res;
				},
				//______________________________________________________________________
				loader(THIS = this){
					document.body.scrollTop = 0;
					window.$.post(this.baseurl+"admin/" + this.$route.params.id, { token: this.$localStorage.get("user") }, function(D){
					
						if(D.status.code=="401"){
							THIS.$localStorage.remove('user');
							THIS.$router.push('/login');
						}else{
							THIS.val.name = D.data.fullname;
							THIS.val.field = D.data.field;
							THIS.val.username = D.data.username;
							THIS.val.email = D.data.email;
							THIS.val.password = D.data.password;
							THIS.val.password2 = D.data.password;
							THIS.val.status = D.data.status;
							THIS.val.access_level = D.data.access_level;
						}
					}, "json");
				},
				//______________________________________________________________________
				field(THIS = this){
					window.$.get(this.baseurl+"field/list", { }, function(D){
						THIS.field_data = D.data;
					}, "json");
				},
				//______________________________________________________________________
				sav(THIS = this){
					let mod = (this.$route.params.id != undefined) ? this.$route.params.id : 'create';
					THIS.loading(THIS);
					window.$.post(this.baseurl+'admin/' + mod, {
						role: this.$localStorage.get('user').username.role,
						name: THIS.val.name,
						field: THIS.val.field,
						email: THIS.val.email,
						username: THIS.val.username,
						password: THIS.val.password,
						status: THIS.val.status,
						access_level: THIS.val.access_level,
						token: this.$localStorage.get("user")
					}, function(D){
						if(D.ok==true){
							THIS.success(THIS);
							THIS.$router.push('/admin/list');
						}else{
							THIS.error(THIS, "نام کاربری تکراری است");
							THIS.val.username = '';
						}
					}, "json");
				},
			}
		}
	</script>
<style>

</style>
